import {
    AutocompleteArrayInput,
    Button,
    CreateButton,
    DateInput,
    ExportButton,
    FilterButton,
    ListToolbar,
    Pagination,
    ReferenceArrayInput,
    SearchInput,
    SelectArrayInput,
    SortButton,
    TopToolbar,
    useListContext,
} from 'react-admin';
import { Card, Stack } from '@mui/material';
import { MissionGridContent } from './MissionGridContent';
import { useMissionTypes } from '@app/mission_type/useMissionType';
import { dateFilterInputProps } from '@core/utils/dateFilterInputProps';
import {
    antennaInputText,
    antennaOptionText,
} from '@app/antenna/AntennaInputOption';
import { MissionTypeChipFromId } from '../chips/MissionTypeChip';

export const MissionGridLayout = () => {
    const { data: missionTypes = [] } = useMissionTypes();

    const { isPending, setFilters, filterValues } = useListContext();

    const missionFilters = [
        <SearchInput
            source="search"
            alwaysOn
            placeholder="Search name, description, partner info, etc."
        />,
        <DateInput
            source="startDate.gte"
            label="Start date after"
            {...dateFilterInputProps}
        />,
        <DateInput
            source="startDate.lte"
            label="Start date before"
            {...dateFilterInputProps}
        />,
        <DateInput
            source="endDate.gte"
            label="End date after"
            {...dateFilterInputProps}
        />,
        <DateInput
            source="endDate.lte"
            label="End date before"
            {...dateFilterInputProps}
        />,
        <DateInput
            source="updatedAt.gte"
            label="Updated after"
            {...dateFilterInputProps}
        />,
        <DateInput
            source="updatedAt.lte"
            label="Updated before"
            {...dateFilterInputProps}
        />,
        <SelectArrayInput
            source="type.in"
            label="Type (or)"
            optionText={record => <MissionTypeChipFromId id={record.id} />}
            choices={missionTypes}
        />,
        <ReferenceArrayInput
            label="Antennas (or)"
            reference="antenna"
            source="antennaId.in"
            sort={{ field: 'name', order: 'ASC' }}
        >
            <AutocompleteArrayInput
                label="Antennas (or)"
                optionText={antennaOptionText}
                inputText={antennaInputText}
                helperText={false}
                filterToQuery={search => ({ search })}
            />
        </ReferenceArrayInput>,
    ];

    const handleClearFilters = () => {
        setFilters({});
    };
    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    if (isPending) return null;
    return (
        <Stack component="div" sx={{ width: '100%' }}>
            <ListToolbar
                filters={missionFilters}
                actions={
                    <MissionActions
                        hasFilters={hasFilters}
                        handleClearFilters={handleClearFilters}
                    />
                }
            />
            <Card>
                <MissionGridContent />
            </Card>
            <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
        </Stack>
    );
};

const MissionActions = ({
    hasFilters,
    handleClearFilters,
}: {
    hasFilters: boolean;
    handleClearFilters: () => void;
}) => {
    return (
        <TopToolbar>
            <FilterButton />
            <SortButton fields={['name', 'updatedAt', 'startDate']} />
            <Button
                disabled={!hasFilters}
                label="Clear all"
                onClick={handleClearFilters}
                variant="outlined"
                size="small"
            />
            <ExportButton />
            <CreateButton
                resource="mission"
                variant="contained"
                label="New Mission"
                sx={{ marginLeft: 2 }}
            />
        </TopToolbar>
    );
};
